import React from 'react';
import styled from 'styled-components';

import Divider from '@/components/atom/Divider';
import theme from '@/styles/theme';
import { Duty } from '@/types/common';

const getWeekDayInfo = (weekDay: number) => {
  switch (weekDay) {
    case 1:
      return { day: '월요일', dayColor: theme.color.gray400 };
    case 2:
      return { day: '화요일', dayColor: theme.color.gray400 };
    case 3:
      return { day: '수요일', dayColor: theme.color.gray400 };
    case 4:
      return { day: '목요일', dayColor: theme.color.gray400 };
    case 5:
      return { day: '금요일', dayColor: theme.color.gray400 };
    case 6:
      return { day: '토요일', dayColor: theme.color.blue700 };
    case 7:
      return { day: '일요일', dayColor: theme.color.red700 };
    default:
      return { day: '공휴일', dayColor: theme.color.red700 };
  }
};

interface Props {
  duties: Duty[];
  todayDuty?: Duty;
}
const DoctorOperationTimeTable = ({ duties, todayDuty }: Props) => {
  const breakTimeDisplay = todayDuty?.isClosed
    ? '휴무'
    : todayDuty?.hasBreakTime
      ? `${todayDuty.breakStartTime} ~ ${todayDuty.breakEndTime}`
      : '없음';

  return (
    <BoxWrapper>
      <InfoWrapper>
        {duties.map((duty) => {
          const { day, dayColor } = getWeekDayInfo(duty.weekDay);
          return (
            <DutyWrapper key={duty.weekDay}>
              <Label color={dayColor}>{day}</Label>
              <Time>{duty.isClosed ? '휴무' : `${duty.openTime} ~ ${duty.closeTime}`}</Time>
            </DutyWrapper>
          );
        })}
      </InfoWrapper>
      <BreakTime>
        <StyledDivider />
        <DutyWrapper>
          <Label>휴게시간</Label>
          <Time>{breakTimeDisplay}</Time>
        </DutyWrapper>
      </BreakTime>
    </BoxWrapper>
  );
};

export default DoctorOperationTimeTable;

const BoxWrapper = styled.div`
  width: 100%;
  padding: 0 24px;
  border-radius: 8px;
`;

const InfoWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
`;

const DutyWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const BreakTime = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const Label = styled.div<{ color?: string }>`
  ${({ theme, color }) => `
    ${theme.typography.UI14R};
    color: ${color ?? theme.color.gray400};
  `}
`;
const Time = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI14M};
    color: ${theme.color.gray700};
  `}
`;

const StyledDivider = styled(Divider)`
  margin: 16px 0px;
`;
